export const ru = {
    nav: {
        apartments: 'Апартаменты',
        location: 'Локация',
        payment: 'Плащане',
        materials: 'Материалы',
        about: 'О комплексе',
        contacts: 'Контакти'
    },
    contactForm: {
        title: 'Свържете се с нас',
        nameLabel: 'Име',
        emailLabel: 'Имейл',
        messageLabel: 'Съобщение',
        submitBtn: 'Изпрати'
    },
    footer: {
        phone: 'Телефон',
        email: 'Имейл',
        address: 'Адрес',
        addressLinkText: 'гр. Варна, кв. Бриз',
        copyright: 'Jura RESIDENCE. All rights reserved.'
    },
    home: {
        heroSliderText: 'Там, где море встречает природу - лучшее местоположение в микрорайоне Бриз',
        heroSliderBtn: 'Выберите вход',
        introLeft: 'Стильные и просторные здания для счастливой семейной жизни',
        introRight: 'Жилой комплекс „ЮРА“ расположен в прекрасном месте, оттуда можно быстро добраться до центра морской столицы и до курортных комплексов „Св.Св.Константин и Елена” и „Золотые пески”. Остановки рейсовых автобусов, которые рядом, способствуют комфортному проезду во всех направлениях.',
        introBtn: 'Дополнительная информация о комплексе',
        chooseApartments: 'Выбор апартаменты',
        viewParking: 'Виж гаражите',
        box1Title: 'Лучшее местоположение',
        box1Text: 'Микрорайон Бриз - один из самых престижных районов для проживания в городе Варна',
        box2Title: 'Отличная коммуникация',
        box2Text: 'Неподалеку от бульвара "Васил Левски" и бульвара "Княз Борис I".',
        box3Title: 'Впечатляющий внешний вид',
        box3Text: 'Впечатляющий фасад из естественных материалов отличного качества.',
        box4Title: 'Природа неподалеку от здания',
        box4Text: 'Апартаменты рядом с Приморским парком и Парком-памятником болгаро-советской дружбы.',
        box5Title: 'Стандарт качества',
        box5Text: 'Застройщики с богатым опытом и высшее качество употребляемых материалов.',
        box6Title: 'Преимущества для жильцов',
        box6Text: 'Подземные гаражи, торговые помещения и офисы, лифты.',
        quickLink1Title: 'Фасад/Материалы',
        quickLink1Text: 'Малоэтажное здание, которое гармонирует с окружающим ландшафтом, соответствует всем требованиям энергоэффективности класса А',
        quickLink2Title: 'Дополнительные преимущества',
        quickLink2Text: 'Апартаменты подготовлены для установления кондиционеров и для газификации. Решена проблема с парковкой.',
        quickLink3Title: 'Уютные апартаменты',
        quickLink3Text: 'Небольшое количество апартаментов в одном подъезде – небольшое количество соседей позволяет комфортно себя чувствовать в своем жилище. Каждый из апартаментов имеет отличный вид из окон и отличную звукоизоляцию.',
        whyJura: 'Зачем выбрать жилой комплекс „Юра“?',
        availableApartments: 'Свободни апартаменти',
        whyJura1Title: 'Высокий стандарт, контроль и гарантии завершенности',
        whyJura1Text: 'Впечатляющий внешний вид здания – наша первостепенная цель. Недвижимость спроектирована в соответствии с последними тенденциями архитектуры и современными требованиями. Хорошая отделка общих частей – это предпосылка прочности и качества.',
        whyJura2Title: 'Престижное местоположение и удобный проезд',
        whyJura2Text: 'Исключительно удобный проезд - до бул.”Васил Левски” и бул.”Княз Борис I”, отсюда есть городской транспорт во всех направлениях. Рядом есть элитные образовательные учреждения. Здание окружено двумя парками. В непосредственной близости находятся Стадион „Варна“, Дельфинарий, теннисные корты и бассейны, детские сады и разнообразныe заведения общепита и места для досуга.',
        whyJura3Title: 'Разнообразие удобных апартаментов',
        whyJura3Text: 'Жилой комплекс „ЮРА состоит из четырех подъездов и включает 52 апартамента площадью от 74 до 300 кв.м.– двухкомнатные, трехкомнатные, четырехкомнатные и многокомнатные с уникальными характеристиками. Небольшое число жилищ, с большими помещениями и со всеми преимуществами выглядит как однофамильный дом.',
    },
    apartments: {
        position: 'Экспозиция',
        east: 'Восток',
        west: 'Запад',
        north: 'Север',
        south: 'Юг',
        northEast: 'Северо-восток',
        northWest: 'Северо-запад',
        southEast: 'Юго-восток',
        southWest: 'Юго-запад',
        available: 'Свободный',
        reserved: 'Зарезервированный',
        sold: 'Проданный',
        goToApartments: 'К апартаменты',
        chooseEntrance: 'Выберите вход',
        chooseFloor: 'Выберите пол',
        inputNumber: 'Въведете номер',
        chooseType: 'Изберете вид',
        inputNetArea: 'Въведете чиста площ',
        inputGrossArea: 'Въведете обща площ',
        inputPosition: 'Въведете изложение',
        chooseStatus: 'Изберете статус',
        twoRoom: 'Двустаен',
        threeRoom: 'Тристаен',
        fourRoom: 'Четиристаен',
        manyRoom: 'Многостаен',
        priceNegotiable: 'Цена договорная'
    },
    parking: {
        available: 'Свободно',
        reserved: 'Резервирано',
        sold: 'Продадено'
    },
    page404: {
        title: 'Ошибка 404',
        text: 'Страница, которую вы ищете, не найдена. Выберите другое меню или вернитесь к началу.'
    },
    messages: {
        messageSentSuccessfully: 'Ваше сообщение отправлено успешно.',
        errorSendingMessage: 'Произошла ошибка отправки сообщения. Повторите попытку позже.',
        requiredFields: 'Все поля обязательны для заполнения.',
        invalidUrl: 'Недействительный URL'
    },
    general: {
        siteName: 'Жилой комплекс "Юра"',
        previousBtn: 'Предыдущий',
        nextBtn: 'Следующий',
        price: 'Цена',
        floor: 'Пол',
        floor_short: 'пол',
        entrance: 'Вход',
        entrance_short: 'вх.',
        number: 'Номер',
        type: 'Тип',
        status: 'Статус',
        area: 'Площадь',
        netArea: 'Чистая площадь',
        grossArea: 'Общая площадь',
        apartment: 'апартамент',
        maisonette: 'мезонет',
        apartment_plural: 'Апартаменти',
        parkingLots: 'Гаражи',
        viewMore: 'Виж повече',
        homeBtn: 'Върни ме в началото',
        home: 'Начало',
        basement: 'Сутерен',
        print: 'Принтирай страницата с апартамента'
    }
}



// WEBPACK FOOTER //
// ./src/utils/translations/ru.js